export default {
    mapLandmarkImport_landmark:'Landmark',
    mapLandmarkImport_ImportTitle:'Import Landmarks',
    mapLandmarkImport_downloadTemplate:'Download Template',
    mapLandmarkImport_fieldsRequied:'File validation failed. Check that all fields are completed and column names match the expected template',
    mapLandmarkImport_formatSupport:'Supported CSV formats: comma, semicolon, tab.',
    mapLandmarkImport_import:'Import',
    mapLandmarkImport_titleEditImport:'The following landmarks were not found.  Please correct any errors',
    mapLandmarkImport_fieldsAdressRequied:'There’s an issue with location data: please ensure Address, Latitude, Longitude (or the required fields) are present and correctly named.',
    mapLandmarkImport_correctErrors:'There were some errors in the import, to correct them click here',
    mapLandmarkImport_success:'Successful import of landmarks',
    mapLandmarkImport_maxSizeFile:'Max file size 5 mb',
    mapLandmarkImport_chooseFile:'Choose File',
    mapLandmarkImport_errorRadius:'Error format column Radius, is not number',
    mapLandmarkImport_errorTag:'Tag not exist',
    mapLandmarkImport_errorAddress:'Error in format Address',
    mapLandmarkImport_columnError: "Columns with errors"
}